import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Immediate Lockdown',
    desc: 'Follow the Chapter 1 guide to secure the physical asset and stop the utilities from eating your cash.'
  }, {
    num: '02',
    title: 'Assert Your Rights',
    desc: 'Use the provided script to notify the bank and create a 30-day "Administrative Stay."'
  }, {
    num: '03',
    title: 'Execute the Exit',
    desc: 'Use the valuation audit to pick the path that puts the most money in your pocket with the least amount of stress.'
  }];
  return <section className="bg-cream py-24 px-4" data-id="element-115">
      <div className="max-w-6xl mx-auto" data-id="element-116">
        <FadeIn className="text-center mb-16" data-id="element-117">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-4" data-id="element-118">
            Three Steps to Take Control
          </h2>
          <div className="w-24 h-px bg-copper mx-auto" data-id="element-119" />
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-120">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-8 left-1/6 right-1/6 h-px bg-copper/30 z-0" data-id="element-121" />

          {steps.map((step, index) => <FadeIn key={index} delay={0.2 * index} className="relative z-10 flex flex-col items-center text-center group" data-id="element-122">
              <div className="w-16 h-16 bg-navy text-copper font-heading font-bold text-2xl flex items-center justify-center rounded-full mb-6 border-4 border-cream shadow-sm group-hover:bg-copper group-hover:text-navy transition-colors duration-300" data-id="element-123">
                {step.num}
              </div>
              <h3 className="text-xl font-heading font-bold text-navy mb-4" data-id="element-124">
                {step.title}
              </h3>
              <p className="text-text-dark/80 font-body leading-relaxed max-w-sm" data-id="element-125">
                {step.desc}
              </p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}